// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { createListenerMiddleware } from '@reduxjs/toolkit';
import { advisoryRepositorySlice } from '@shared/data-access/slices/advisory-repository';
import { advisoryApi } from '@shared/data-access/api/brokerage/advisory-api.v2';
import {
  clientsSlice,
  selectInstitutionsByClientIdAndIds,
} from '@shared/data-access/slices/clients';

export const syncInstitutionsMiddleware = createListenerMiddleware();

syncInstitutionsMiddleware.startListening({
  matcher: advisoryApi.endpoints.syncInstitutionsSyncBatchIdStatus.matchFulfilled,
  effect: ({ payload }, { dispatch, getState }) => {
    const clientId = payload.client_id ?? 0;

    const connections = Object.keys(payload?.connections ?? {});

    const institutions = selectInstitutionsByClientIdAndIds(
      getState() as any,
      clientId,
      connections,
    );

    const institutionIds = institutions.map(institution => institution.id);

    dispatch(
      advisoryRepositorySlice.actions.resetByClientAndInstitutionId({
        clientId: clientId,
        institutions: institutionIds,
      }),
    );

    dispatch(clientsSlice.actions.removePendingInstitutions(connections));
  },
});
